"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenWidget = exports.createHtmlFromTokenWidget = void 0;
var createHtmlFromTokenWidget = function () {
    throw new Error("Should not be rendered as Html");
};
exports.createHtmlFromTokenWidget = createHtmlFromTokenWidget;
var TokenWidget = function () {
    throw new Error("Should not be rendered on the public page");
};
exports.TokenWidget = TokenWidget;
